export default __webpack_public_path__ + "static/media/EventIconSiderClicked.2e9834df.svg";